<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Pedido, Cliente, ..."
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">


          <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

          <t-input-person customer
                          v-model="form.customerId" />

          <t-input-search v-model="form.saleOrderStatusId" :options="typeSaleOrderStatusOptions" select
                          label="Status Pedido"/>

        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               link-primary-column="orderNumber"
               primary-key-column="orderNumber">

        <template #first-column="{item}">

          <t-list-link-primary formatter="lpad:4"
                               :label="item.orderNumber" :userAuth="userAuth" :id="item.orderNumber"
                               :path="currentPage.path"/>



        </template>



      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'SaleOrder',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      form: {
        customerId: 0,
        saleOrderStatusId: 0,
        sellerId:0,
        paymentPlanId:0,
        contactId:0,
        companyId:0,
        issueDate: "",
      },
      fields: [
        {key: "orderNumber", label: "Cód. Pedido"},
        {key: "customerNameAutomatically", label: "Cliente"},
        {key: "customerGroup", label: "Grupo"},
        {key: "customerCityFull", label: "Cidade/UF"},
        {key: "qtyItems", label: "Qtd. Itens"},
        {key: "amount", label: "Valor Total", formatter: "number"},
        {key: "statusSale", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeSaleOrderStatusOptions: [],
      companyOptions: [],
      paymentPlanOptions: [],
      sellerOptions: [],
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {
      delete this.form.status
    },
    async mountedContinued() {

      await http.list(this.userAuth.currentPage.path + "/selectRelationList").then((response) => {

        this.typeSaleOrderStatusOptions = response.typeSaleOrderStatusOptions
        this.companyOptions = response.typeQuoteStatusOptions
        this.paymentPlanOptions = response.typeQuoteStatusOptions
        this.sellerOptions = response.typeQuoteStatusOptions

      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
}
</script>
